import React, { useContext, type FC, type ReactNode, useState, useCallback } from 'react';

const RefreshContext = React.createContext<{
  isHttpApi: boolean;
  refreshTime: number;
  updateRefresh: (delayMs?: number) => void;
  updateIsHttpApi: (value: boolean) => void;
}>({
  isHttpApi: true,
  refreshTime: 0,
  updateRefresh: () => {},
  updateIsHttpApi: () => {},
});

export const useRefreshTime = () => {
  return useContext(RefreshContext);
};

export const RefreshProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [currentTime, setCurrentTime] = useState(0);
  const [isHttpApi, setIsHttpApi] = useState(true);

  const update = useCallback((delayMs: number = 0) => {
    const timer = setTimeout(() => {
      // http.clearCache();
      setCurrentTime(Date.now());
      clearTimeout(timer);
    }, delayMs);
  }, []);

  return (
    <RefreshContext.Provider
      value={{
        isHttpApi,
        refreshTime: currentTime,
        updateRefresh: update,
        updateIsHttpApi: setIsHttpApi,
      }}
    >
      {children}
    </RefreshContext.Provider>
  );
};
